"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isFinite = _interopRequireDefault(require("lodash/isFinite"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ControlRoomUtils = exports["default"] = /*#__PURE__*/function () {
  function ControlRoomUtils() {
    _classCallCheck(this, ControlRoomUtils);
  }
  return _createClass(ControlRoomUtils, null, [{
    key: "validateParentData",
    value: function validateParentData(height, width, top, left) {
      if (!(0, _isFinite["default"])(height)) {
        return false;
      }
      if (!(0, _isFinite["default"])(width)) {
        return false;
      }
      if (!(0, _isFinite["default"])(top)) {
        return false;
      }
      if (!(0, _isFinite["default"])(left)) {
        return false;
      }
      return true;
    }
  }, {
    key: "toProportion",
    value: function toProportion() {
      var childData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var parentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pHeight = parseInt(parentData.height, 10);
      var pWidth = parseInt(parentData.width, 10);
      var pLeft = parseInt(parentData.left, 10);
      var pTop = parseInt(parentData.top, 10);
      var DEFAULT_WIDTH = 700;
      var DEFAULT_HEIGHT = 300;
      var DEFAULT_TOP = 100;
      var DEFAULT_LEFT = 100;
      var isValidParentData = ControlRoomUtils.validateParentData(pHeight, pWidth, pTop, pLeft);
      var _childData$dimensions = childData.dimensions,
        _childData$dimensions2 = _childData$dimensions === void 0 ? {} : _childData$dimensions,
        _childData$dimensions3 = _childData$dimensions2.height,
        height = _childData$dimensions3 === void 0 ? DEFAULT_HEIGHT : _childData$dimensions3,
        _childData$dimensions4 = _childData$dimensions2.width,
        width = _childData$dimensions4 === void 0 ? DEFAULT_WIDTH : _childData$dimensions4,
        _childData$coordinate = childData.coordinates,
        _childData$coordinate2 = _childData$coordinate === void 0 ? {} : _childData$coordinate,
        _childData$coordinate3 = _childData$coordinate2.top,
        top = _childData$coordinate3 === void 0 ? DEFAULT_TOP : _childData$coordinate3,
        _childData$coordinate4 = _childData$coordinate2.left,
        left = _childData$coordinate4 === void 0 ? DEFAULT_LEFT : _childData$coordinate4;
      var adjustedChildData = {
        dimensions: {
          height: (0, _isFinite["default"])(height) ? height : DEFAULT_HEIGHT,
          width: (0, _isFinite["default"])(width) ? width : DEFAULT_WIDTH
        },
        coordinates: {
          top: (0, _isFinite["default"])(top) ? top : DEFAULT_TOP,
          left: (0, _isFinite["default"])(left) ? left : DEFAULT_LEFT
        }
      };
      if (!isValidParentData) {
        console.error("Invalid parent data: ".concat(parentData));
      }
      var percentageHeight = adjustedChildData.dimensions.height / pHeight;
      var percentageWidth = adjustedChildData.dimensions.width / pWidth;
      percentageHeight = percentageHeight > 1 ? 1 : percentageHeight;
      percentageWidth = percentageWidth > 1 ? 1 : percentageWidth;
      percentageHeight = percentageHeight < 0 ? 0 : percentageHeight;
      percentageWidth = percentageWidth < 0 ? 0 : percentageWidth;
      var percentageLeft = (adjustedChildData.coordinates.left - pLeft) / pWidth;
      var percentageTop = (adjustedChildData.coordinates.top - pTop) / pHeight;
      percentageLeft = percentageLeft > 1 ? 1 : percentageLeft;
      percentageTop = percentageTop > 1 ? 1 : percentageTop;
      percentageLeft = percentageLeft < 0 ? 0 : percentageLeft;
      percentageTop = percentageTop < 0 ? 0 : percentageTop;
      return {
        coordinates: {
          left: percentageLeft,
          top: percentageTop
        },
        dimensions: {
          width: percentageWidth,
          height: percentageHeight
        }
      };
    }
  }, {
    key: "fromProportion",
    value: function fromProportion() {
      var childData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var parentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pHeight = parseInt(parentData.height, 10);
      var pWidth = parseInt(parentData.width, 10);
      var pLeft = parseInt(parentData.left, 10);
      var pTop = parseInt(parentData.top, 10);
      var DEFAULT_WIDTH = 0.5;
      var DEFAULT_HEIGHT = 0.5;
      var DEFAULT_TOP = 0.25;
      var DEFAULT_LEFT = 0.25;
      var isValidParentData = ControlRoomUtils.validateParentData(pHeight, pWidth, pTop, pLeft);
      var _childData$dimensions5 = childData.dimensions,
        _childData$dimensions6 = _childData$dimensions5 === void 0 ? {} : _childData$dimensions5,
        _childData$dimensions7 = _childData$dimensions6.height,
        height = _childData$dimensions7 === void 0 ? DEFAULT_HEIGHT : _childData$dimensions7,
        _childData$dimensions8 = _childData$dimensions6.width,
        width = _childData$dimensions8 === void 0 ? DEFAULT_WIDTH : _childData$dimensions8,
        _childData$coordinate5 = childData.coordinates,
        _childData$coordinate6 = _childData$coordinate5 === void 0 ? {} : _childData$coordinate5,
        _childData$coordinate7 = _childData$coordinate6.top,
        top = _childData$coordinate7 === void 0 ? DEFAULT_TOP : _childData$coordinate7,
        _childData$coordinate8 = _childData$coordinate6.left,
        left = _childData$coordinate8 === void 0 ? DEFAULT_LEFT : _childData$coordinate8;
      var adjustedChildData = {
        dimensions: {
          height: (0, _isFinite["default"])(height) ? height : DEFAULT_HEIGHT,
          width: (0, _isFinite["default"])(width) ? width : DEFAULT_WIDTH
        },
        coordinates: {
          top: (0, _isFinite["default"])(top) ? top : DEFAULT_TOP,
          left: (0, _isFinite["default"])(left) ? left : DEFAULT_LEFT
        }
      };
      if (!isValidParentData) {
        console.error("Invalid parent data: ".concat(parentData));
      }
      var pxHeight = adjustedChildData.dimensions.height * pHeight;
      var pxWidth = adjustedChildData.dimensions.width * pWidth;
      var pxTop = adjustedChildData.coordinates.top * pHeight + pTop;
      var pxLeft = adjustedChildData.coordinates.left * pWidth + pLeft;
      return {
        coordinates: {
          left: pxLeft,
          top: pxTop
        },
        dimensions: {
          width: pxWidth,
          height: pxHeight
        }
      };
    }
  }]);
}();
_defineProperty(ControlRoomUtils, "WORKSPACE_ASPECT_RATIO", 1.95);
_defineProperty(ControlRoomUtils, "reorderArray", function (array, moving, moveTo) {
  var movingKey = array.indexOf(moving);
  var movingTo = array.indexOf(moveTo);

  // remove the element we're moving from the array
  var movingEntry = array.splice(movingKey, 1)[0];
  array.splice(movingTo, 0, movingEntry);
  return array;
});